import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

declare const lucide: any;

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {
  isCollapsed = false;
  showUserMenu = false;
  userEmail = 'User';
  userRole = 'User';
  userType = '';

  constructor(private router: Router) {}

  ngOnInit() {
    this.loadUserInfo();
  }

  ngAfterViewInit() {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  loadUserInfo() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.userEmail = user.email || 'User';
        this.userRole = user.user_type || 'User';
        this.userType = user.user_type?.toLowerCase() || '';
      } catch {
        // If parsing fails, keep default values
      }
    }
  }

  get userInitials(): string {
    if (!this.userEmail) {
      return 'U';
    }

    const email = this.userEmail.trim().split('@')[0];
    const parts = email.replace(/[^a-zA-Z0-9]+/g, ' ').trim().split(' ').filter(Boolean);

    if (parts.length === 0) {
      return email.slice(0, 2).toUpperCase();
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  isAdmin(): boolean {
    return this.userType === 'admin' || this.userType === 'super_admin';
  }

  isDistributor(): boolean {
    return this.userType === 'distributor';
  }

  isStaff(): boolean {
    return this.userType === 'staff';
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    this.router.navigate(['/login']);
  }

  goToSettings() {
    this.showUserMenu = false;
    this.router.navigate(['/settings']);
  }
}
